import { useState, useEffect } from 'react'

const getMatchedResolution = (breakpoints) => {
	const isSmallResolution =
		window.innerWidth <= (parseFloat(breakpoints.small) || 800)
	const isLarge =
		window.innerWidth > (parseFloat(breakpoints.large) || 1000) &&
		window.innerWidth < (parseFloat(breakpoints.larger) || 1440)
	const isLarger =
		window.innerWidth >= (parseFloat(breakpoints.larger) || 1440)
	if (isSmallResolution) {
		return 'small'
	} else if (isLarge) {
		return 'large'
	} else if (isLarger) {
		return 'larger'
	} else {
		return 'medium'
	}
}

const useMediaQuery = (breakpoints = {}) => {
	const [matchedMedia, setMatchedMedia] = useState(
		getMatchedResolution(breakpoints)
	)
	useEffect(() => {
		let idle
		const checkMatch = () => {
			idle = requestAnimationFrame(() => {
				setMatchedMedia((prev) => {
					const currentMedia = getMatchedResolution(breakpoints)
					return currentMedia !== prev ? currentMedia : prev
				})
			}, 100)
		}
		window.addEventListener('resize', checkMatch)
		return () => {
			cancelAnimationFrame(idle)
			window.removeEventListener('resize', checkMatch)
		}
	}, [breakpoints])

	return matchedMedia
}

export default useMediaQuery
